import * as React from 'react';
import { Box } from '@mui/material';
import ConfigureNewUser from './ConfigureNewUser';
import UserCreationContextProvider from './UserCreationContextProvider';

export default function NewUser() {
  return (
    <Box sx={{ width: '100%', flexDirection: 'column', display: 'flex' }}>
      <UserCreationContextProvider>
        <ConfigureNewUser/>
      </UserCreationContextProvider>
    </Box>
  );
}
